import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { from, Subscription } from 'rxjs';
import { LfsaBotonEditarGridComponent} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { DesbloqueoOrdenBalanzaService } from '../../services/desbloqueo-orden-balanza.service';
import { moduloGaritas } from '../../diccionarios/balanzaModulo.js';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { formatDate } from '@angular/common';
import { OrdenBalanzaService } from '../../services/orden-balanza.service';
import { MantenimientoUsuarioAprobadorService } from '../../services/mantenimiento-usuario-aprobador.service';
import { ConfiguracionMotivosDeDesbloqueosService } from '../../services/configuracion-motivos-de-desbloqueos.service';
import { UsuarioBasculaGaritaService } from '../../services/usuario-bascula-garita.service';
import { MaterialService } from '../../services/material.service';
import { ProveedorService } from '../../services/proveedor.service';
import { ClienteService } from '../../services/cliente.service';
import { AlmacenService } from '../../services/almacen.service';
import { CentrosService } from '../../services/centros.service';
import { PlacaService } from '../../services/placa-transportista.service';
import { CatalogoBalanzaService } from '../../services/catalogoBalanza.service';
import { event } from 'jquery';

@Component({
  selector: 'app-desbloqueo-orden-balanza',
  templateUrl: './desbloqueo-orden-balanza.component.html',
  styleUrls: ['./desbloqueo-orden-balanza.component.css']
})
export class DesbloqueoOrdenBalanzaComponent implements OnInit, OnDestroy {

  motivosCmb: any[] = [];

  public DAT_TITULOS: any = moduloGaritas.titulos.desbloqueoOrdenBalanza;
  public DAT_BTNS: any = moduloGaritas.button.buttonsNombre;
  public DAT_AG_GRID: any = moduloGaritas.agGrid;
  public DAT_MSG: any = moduloGaritas.mensajes;

  public gridApi: any;
  public gridColumnApi: any;
  public frameworkComponents: any;
  public columnDefs: any[] = [];
  public rowData: any[] = [];

  public isCreate: boolean = true;
  public tituloModal: string = '';
  public loading: boolean = false;
  public isValidForm: boolean = false;
  public agregarForm = new FormGroup({
    idOrden: new FormControl(null, [Validators.required]),
    proveedor: new FormControl(null, []),
    autoriza: new FormControl("SI", [Validators.required]),
    material: new FormControl(null, []),
    ejecutado: new FormControl(null, []),
    horaAuth: new FormControl(null, []),
    usuarioAutoriza: new FormControl(null, [Validators.required]),//usuario de sesion modificable
    fechaAuth: new FormControl(null, []),
    usuarioCaptura: new FormControl(null, [Validators.required]),
    fechaHoraCaptura: new FormControl(null, []),
    tipo: new FormControl(null, []),
    loteInsp: new FormControl(null, []),
    acidez: new FormControl(null, []),
    acidezSap: new FormControl(null, []),
    impureza: new FormControl(null, []),
    impurezaSap: new FormControl(null, []),
    humedad: new FormControl(null, []),
    humedadSap: new FormControl(null, []),
    difAcidez: new FormControl(null, []),
    difHumedad: new FormControl(null, []),
    difImpureza: new FormControl(null, []),
    tolerancia: new FormControl(null, []),
    pesoIn: new FormControl(null, []),
    pesoOut: new FormControl(null, []),
    nivel: new FormControl(null, []),
    tipoSap: new FormControl(null, []),
    fechaActual: new FormControl(null, [Validators.required]),
    motivo: new FormControl(null, [Validators.required]),
    observacion: new FormControl(null, []),
    // aumente
    pesoNetoBalanza: new FormControl (null, []),
    pesoNeto: new FormControl (null, []),
  });

  public ordenSelected: any;
  public cmbTipoOrden: any[] = [];
  public showIngresoVacio = false;
  public tipoTolerancia: string;
  public tituloGrid: string = "Desbloqueo Orden de Balanza - registros activos por desbloquear";

  public listMotivos: any[];

  public ordenBalanzaForm = new FormGroup({
    // Mantenimiento de Ordenes de Balanza
    estado: new FormControl(0),
    orden: new FormControl(null),
    fecha: new FormControl(null),
    tipo: new FormControl(null, [Validators.required]),
    numero: new FormControl(null, [Validators.required]),
    numOrdAlt: new FormControl(null, []),
    emptyIncome: new FormControl(null),
    freightNumber: new FormControl(null),
    factura: new FormControl(null),
    guia: new FormControl(null),
    proveedorId: new FormControl(null),
    proveedor: new FormControl(null),
    cliente: new FormControl(null),
    ordBalanzaOrigen: new FormControl(null),
    pesoBalanzaOrigen: new FormControl(null),
    sellos: new FormControl(null),
    contenedor: new FormControl(null, [Validators.maxLength(12)]),
    material: new FormControl(null, [Validators.pattern(/[0-9]+/)]),
    desmat: new FormControl(null),
    despro: new FormControl(null),
    descli: new FormControl(null),

    // INFO DEL TICKET DE AUTORIZACIÓN DE TRANSPORTE
    ticketAuth: new FormControl(null, [Validators.required, Validators.pattern(/[0-9]+/)]),
    placa: new FormControl(null, [Validators.required, Validators.pattern(/[A-Za-z]+/)]),
    chofer: new FormControl(null, [Validators.required]),
    cedChofer: new FormControl(null, [Validators.required]),
    // ORIGEN
    centroOri: new FormControl(null, [Validators.pattern(/[A-Za-z0-9]+/)]),
    almanceOri: new FormControl(null, [Validators.pattern(/[A-Za-z]+/)]),
    // DESTINO
    centroDest: new FormControl(null, [Validators.pattern(/[A-Za-z0-9]+/)]),
    almaceDest: new FormControl(null, [Validators.pattern(/[A-Za-z]+/)]),

    // Datos recibidos del proveedor
    // DATOS RECIBIDOS
    origOrd: new FormControl(null),
    pesoBruto: new FormControl(null),
    pesoNeto: new FormControl(null),
    tara: new FormControl(null),
    // CALIDAD RECIBIDA
    acidez: new FormControl(null),
    humedad: new FormControl(null),
    impureza: new FormControl(null),

    //Tipo de Orden
    clasePerdido: new FormControl('', [Validators.maxLength(4)]),
    orgCompra: new FormControl('', []),
    grupoCompra: new FormControl('', []),

    // Orden de compra
    ocStatus: new FormControl(null),
    solpedNumber: new FormControl(null),
    ocNumber: new FormControl(null),
    creationDateOC: new FormControl(null),
    updateDateOC: new FormControl(null),

    // Informaciín del lote de inspección
    loteInsp: new FormControl(null),
    decisionEmpleo: new FormControl(null),
    gradoApi: new FormControl(null),
    calidad: new FormControl(null),
    inspectionLotAcidity: new FormControl(null),
    inspectionLotMoisture: new FormControl(null),
    inspectionLotImpurity: new FormControl(null),

    // Captura de pesos Entrada/Salida
    // CAPTURA DE PESOS ENTRADA
    fechIn: new FormControl(null, Validators.required),
    horaEntrada: new FormControl(null, Validators.required),
    pesoIn: new FormControl(null, Validators.required),
    // CAPTURA DE PESOS SALIDA
    fechOut: new FormControl(null),
    horaSalida: new FormControl(null),
    pesoOut: new FormControl(null),

    // Información de la Balanza
    idOrden: new FormControl(null),
    ordenFija: new FormControl(null, [Validators.required]),
    ordenFijaDescription: new FormControl(null, [Validators.required]),
    idusuario: new FormControl(null, [Validators.required]),
    usuario: new FormControl(null, [Validators.required]),
  });

  public showUsers: boolean = false;
  public cmbUsuarios : any[] = [];
  private userName = localStorage.getItem('userName');
  private subscription = new Subscription();

  public frmFiltros = new FormGroup({
    orden : new FormControl('', []),
    inicio: new FormControl('', []),
    fin  : new FormControl('', []),
  });

  constructor(
    private _util: UtilsService,
    private desbloqueoOrdenBalanzaS: DesbloqueoOrdenBalanzaService,
    private ordenBalanzaService: OrdenBalanzaService,
    private MantenimientoUsuarioAprobadorService: MantenimientoUsuarioAprobadorService,
    private ConfiguracionMotivosDeDesbloqueosService: ConfiguracionMotivosDeDesbloqueosService,
    private materialS: MaterialService,
    private proveedorS: ProveedorService,
    private clienteS: ClienteService,
    private almacenS: AlmacenService,
    private centrosS: CentrosService,
    private placaS: PlacaService,
    private catalogoOB: CatalogoBalanzaService,
  ) {
  }

  tipoDesbloqueo;

  ngOnInit() {
    this.girdComponent();
    this.iniciarlizarCombos();
    this.obtenerTodo();
    this.tituloModal = this.DAT_TITULOS.tituloActualizar;

    this.agregarForm.get("tipo").disable();
    this.agregarForm.get("fechaActual").disable();
    this.agregarForm.get("tolerancia").disable();
    this.agregarForm.get("usuarioAutoriza").disable();
    this.agregarForm.get("difAcidez")?.disable();
    this.agregarForm.get("difHumedad")?.disable();
    this.agregarForm.get("difImpureza")?.disable();
    
  }

  motivos(tipo) {
    let tipoDesc;

    switch (tipo) {
      case 0:
        tipoDesc = "Compra";
        break;
      case 1:
        tipoDesc = "Venta";
        break;
      case 2:
        tipoDesc = "Informativo";
        break;
      case 3:
        tipoDesc = "Traslado";
        break;
      case 4:
        tipoDesc = "Maquila";
        break;

      default:
        break;
    }
    this.motivosCmb =[];
    console.log("TIPO y TIPODESC ", tipo + "-", tipoDesc);
    console.log("MOTIVOSFILTRADOS", this.listMotivos.filter(e => e.tipoOrd.indexOf(tipoDesc) >= 0))
    this.motivosCmb = this.listMotivos.filter(e => e.tipoOrd.indexOf(tipoDesc) >= 0);
  }

  getOrdenBalanzaById(balanzaId): Promise<any> {
    //this.subscription.add(//);
    return this.ordenBalanzaService.obtenerPorId(balanzaId).toPromise();

  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'SECU',
        field: 'secuencia',
        sortable: true,
        filter: true,
        width: 100,
      },
      {
        headerName: 'Ord. Balanza',
        field: 'idOrden',
        sortable: true,
        filter: true,
        width: 150,
      },
      {
        headerName: 'Fecha Ord. Balanza/Desbloqueos',
        field: 'fecha',
        sortable: true,
        filter: true,
        cellRenderer: (data) => {
          return data.value ? formatDate(new Date(data.value), 'dd-MM-yyyy HH:mm', 'en') : ''
        }
      },
      {
        headerName: 'Tipo Bloqueo',
        field: 'tipo_bloqueo',
        sortable: true,
        filter: true,
        width: 230,
        resizable: true
      },
      /*{
        headerName: 'Estado Orden',
        field: 'estado_orden',
        sortable: true,
        filter: true,
      },*/
      {
        headerName: 'Dif. (Pesos)',
        field: 'difPeso',
        sortable: true,
        filter: true,
        width: 150,
      },
      {
        headerName: 'Dif. Calidad (Acidez)',
        field: 'difAcidez',
        sortable: true,
        filter: true,
        width: 220,
      },
      {
        headerName: 'Dif. Calidad (H+I)',
        field: 'difHI',
        sortable: true,
        filter: true,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 90,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.editar,
          // colorBoton: this.DAT_BTNCSS.info,
        },
      },
    ];
  }
  
  placaResponse;
  buscarPlacaTransporte(placa: string) {
    this.placaResponse = {} as any;
    this.agregarForm.get('chofer').reset();
    this.agregarForm.get('cedChofer').reset();

    this.placaS.obtenerPorId(placa).subscribe(
      resp => {
        if (resp) {
          this.placaResponse = resp;
          this.agregarForm.get('chofer').setValue(resp.chofer.trim());
          this.agregarForm.get('cedChofer').setValue(resp.cedula.trim());
          return;
        }
        this.placaResponse = {} as any;
        this._util.mensajeErroToast('Placa transportista incorrecto.');
      },
      error => {
        this.placaResponse = {} as any;
        this._util.mensajeErroToast('Ocurrió un error inesperado, inténtelo nuevamente.');
      }
    );
  }

  public almacenesCmb: any[] = [];
  public centrosCmb: any[] = [];
  obtenerCentros() {
    this.centrosS.obtenerTodo().subscribe(
      resp => {
        this.centrosCmb = resp;
      }
    );
  }

  obtenerAlmacenes() {
    this.almacenS.obtenerTodo().subscribe(
      resp => {
        this.almacenesCmb = resp;
      }
    );
  }

  dataEditar;
  status;
  BLOQUEADO_DIF_CALIDAD;
  ordenSelectedView = false;
  // TIPO DE TOLERANCIA = 0-KILOS, 1-PORCENTAJE - 2 NOAPLICA (EN TIPO DE ORDEN)
  // TIPO = 0-DF-KILOS, 1DIF-CALIDAD (EN REGISTRO DE BLOQUEO)
  // 19-11-2024 REFACTORIZADO, KD: se quitan metodos que no hacen nada y reduncia en declaraciones
  async editar({ rowData }) {
    console.log("Resgistro de Edición rowData", rowData);
    
    this.isCreate = true;
    this.loading = true;
    this.BLOQUEADO_DIF_CALIDAD = false;
    this.dataEditar  = rowData; 
    this.ordenSelected = [];
    
    let userData = JSON.parse(localStorage.getItem('datosUsuarioLogin')).login2;
    this.agregarForm.reset();

    try {
      //Más de 1 registro en bloqueos activos, el Historico solo muestra el registro de bloqueo
      if(rowData.length > 0){
        this.ordenSelected = rowData[0];
        this.dataEditar = rowData[rowData.length - 1]; //this.dataEditar = rowData[1];
      }else{
        this.ordenSelected = await this.getOrdenBalanzaById(rowData.idOrden);
        userData = this.ordenSelected.usuarioGestor;
        this.isCreate = false;
      }

      this.BLOQUEADO_DIF_CALIDAD = this.dataEditar.tipo == this.catalogoOB.tipoBloqueoOB().BLOQUEO_POR_CALIDAD;

      // Campos a llenar provinientes de la Orden de Balanza, La ob debe existir sino notificará Error
      if (this.ordenSelected != undefined) {
        this.motivos(this.ordenSelected.tipoOrden.tipOrden);
        let pesoNetoBalanza = Math.abs(this.ordenSelected.pesoIn - this.ordenSelected.pesoOut);
        this.tipoTolerancia = this.ordenSelected.tipoOrden.tipoTolerancia;
  
        this.agregarForm.patchValue(this.ordenSelected);
        this.agregarForm.get("tipo").setValue(this.ordenSelected.tipoOrden.desca);
        this.agregarForm.get("tolerancia").setValue(this.ordenSelected.tipoOrden.tipOrden == 0 ? "POR NIVEL": this.ordenSelected.tipoOrden.tolerancia);    
        this.agregarForm.get("pesoNetoBalanza").setValue(pesoNetoBalanza); // visualiza pesoNeto
        this.agregarForm.get('usuarioCaptura').setValue(userData);
      }else{
        this._util.mensajeErroToast('Campos con errores o vacios. No se encontró la Orden de balanza.');
      }

      this.agregarForm.get("tipoSap").setValue(this.dataEditar.tipo);
      this.agregarForm.get("nivel").setValue(this.dataEditar.nivel);
      this.agregarForm.get("motivo").setValue(this.dataEditar.motivo);
      this.agregarForm.get("difAcidez").setValue(this.dataEditar.difAcidez);
      this.agregarForm.get("difImpureza").setValue(this.dataEditar.difImpureza);
      this.agregarForm.get("difHumedad").setValue(this.dataEditar.difHumedad);
      this.agregarForm.get("autoriza").setValue(this.dataEditar.autoriza);
      //this.agregarForm.get('usuarioAutoriza').reset();
      
      if(this.isCreate){
        this.agregarForm.get("fechaActual").setValue(formatDate(new Date(), 'dd-MM-yyyy HH:mm:ss', 'en'));
        this.agregarForm.get("autoriza").setValue("SI");
      }

      //Detalle del Material
      this.materialS.obtenerPorId(this.agregarForm.get("material").value).subscribe(
        (resp) => {
          if (resp)
            this.agregarForm.get("material")?.setValue(resp.idMaterial +"-"+ resp.dscaMaterial);
          }
      );
      //Detalle del proveedor de aplicar
      if(this.ordenSelected.proveedor){
        this.proveedorS.obtenerPorId(this.ordenSelected.proveedor).subscribe(e=>{
          this.agregarForm.get("proveedor")?.setValue(e.idProveedor +"-"+ e.nombre);
          this.ordenBalanzaForm.get("proveedor").value(e.ruc);
          this.ordenSelected.proveedor = e.ruc;
        });
      }
      
      this.loading = false;
      this.openModal();

    }catch (error) {
        console.error('Error al buscar la Orden de Balanza:', error);
    }
    
  }

  obtenerTodo() {
    this.loading = true;
    let userData = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    this.subscription.add(
      // this.desbloqueoOrdenBalanzaS.buscarDesbloqueos(this.tipoDesbloqueo, userData.login).subscribe(
      this.desbloqueoOrdenBalanzaS.buscarDesbloqueos(userData.login).subscribe(
        (resp) => {
          console.log("ORDEN DE BALANZA1", resp);

          resp.map(e => {
            e['id'] = e.length > 1 ? e[e.length - 1].id : null;
            e['fecha'] = e[0].fecha;
            e['tipo_bloqueo'] = e[1].tipo;
            e['idOrden'] = e[0].idOrden;
            e['idbloqueo'] = e[1].id;
            e['estado_orden'] = e[0].estado;
            e['usuario'] = e.length > 1 ? e[e.length - 1].usuarioAutoriza : null;
            e['autorizado'] = e.length > 1 ? e[e.length - 1].autoriza : null;
            e['difPeso'] = e.length > 1 ? e[e.length - 1].difPeso : null;
            e['difAcidez'] = e.length > 1 ? e[e.length - 1].difAcidez : null;
            e['difHI'] = e.length > 1 ? e[e.length - 1].difHumedadimp : null;
            e['secuencia'] = e.length > 1 ? e[e.length - 1].secuencia : null;
            return e;
          }).sort((a, b) => (parseInt(a.id) > parseInt(b.id) ? -1 : 1));
          console.log("ORDEN DE BALANZA2", resp)
          this.rowData = resp;
          this.loading = false;
        },
        (error) => {
          this.rowData = [];
          this.loading = false;
        }
      )
    );
  }

  guardarCrearNueva() {
    // || !this.isValidForm
    if (this.agregarForm.invalid) {
      this._util.mensajeErroToast('Registro de Bloqueo inválido. Favor revisar datos');
      return;
    }
    
    this.loading = true;

    let data = {
      ordBalanza: this.ordenSelected,
      mantBloqueOrdBalanza: this.dataEditar
    };

    data.mantBloqueOrdBalanza.autoriza = this.agregarForm.get("autoriza").value;
    data.mantBloqueOrdBalanza.usuarioAutoriza = this.agregarForm.get("usuarioAutoriza").value;
    data.mantBloqueOrdBalanza.obserbacion = this.agregarForm.get("observacion").value;
    data.mantBloqueOrdBalanza.motivo = this.agregarForm.get("motivo").value.substr(0, 40);

    console.log("dataEditar", this.dataEditar);
    console.log("DATA FINAL", data);

    this._util.confirmarSincronoPromesa({
        title: this.DAT_MSG.procesar,
        text: `Desbloqueo orden: ${this.agregarForm.get('idOrden').value}`,
        action: this.DAT_BTNS.nuevo,
        funcion: this.desbloqueoOrdenBalanzaS.desbloqueo(data),
      }).then(() => {
        this.obtenerTodo();
        this.loading = false;
        this.closeModal();
      }).catch(() => {
        this.loading = false;
      });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    this.guardarCrearNueva();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  searchUsers() {
    if (this.showUsers) {
      this.showUsers = false;
      this.cmbUsuarios = [];
      return;
    }
    //this.loading = true;
    //this.showUsers = false;
    this.showUsers = true;
    //this.loading = false;

    this.agregarForm.get('usuarioAutoriza').disable({ onlySelf: true });
  }

  selectedUser(cmb) {
    this.showUsers = false;
    this.agregarForm.get('usuarioAutoriza').setValue(`${cmb.id} - ${cmb.nombre}`);
    this.agregarForm.get('usuarioAutoriza').disable({ onlySelf: true });
  }

  materialInvalido = false;
  proveedorInvalido = false;
  clienteInvalido = false;
  onChangeMaterial(event: any) {
    if (event.key == " " || event.code == "Space" || event.keyCode == 32) return;
    this.loading = true;
    this.materialS.obtenerPorId(this.ordenBalanzaForm.get("material").value).subscribe(
      (resp) => {
        if (resp) {
          this.materialInvalido = false;
          this.ordenBalanzaForm.controls['desmat'].setValue(resp.dscaMaterial);
        } else {
          this.materialInvalido = true;
          this.ordenBalanzaForm.controls['desmat'].setValue('');
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.materialInvalido = true;
        this.ordenBalanzaForm.controls['desmat'].setValue('');
      }
    );
  }

  onChangeProveedor(event: any) {
    if (event.key == " " || event.code == "Space" || event.keyCode == 32) return;
    this.loading = true;
    this.ordenBalanzaForm.controls['despro'].setValue('');

    if (this.ordenBalanzaForm.get("proveedor").value != null && this.ordenBalanzaForm.get("proveedor").value.length > 0) {
      this.proveedorS.obtenerPorRuc(this.ordenBalanzaForm.get("proveedor").value).subscribe(
        (resp) => {
          if (resp) {
            this.proveedorInvalido = false;
            this.ordenBalanzaForm.controls['despro'].setValue(resp.idProveedor + " - " + resp.nombre);
            this.ordenBalanzaForm.controls['proveedorId'].setValue(resp.idProveedor);
          } else {
            this.proveedorInvalido = true;
          }
          this.loading = false;
        },(error) => {
          this.loading = false;
          this.proveedorInvalido = true;
        });
      }
  }

  onChangeCliente(event: any) {
    if (event.key == " " || event.code == "Space" || event.keyCode == 32) return;
    this.loading = true;
    if (this.ordenBalanzaForm.get("cliente").value != null && this.ordenBalanzaForm.get("cliente").value.length > 0) {
      this.clienteS.obtenerPorId(this.ordenBalanzaForm.get("cliente").value).subscribe(
        (resp) => {
          if (resp) {
            this.clienteInvalido = false;
            this.ordenBalanzaForm.controls['descli'].setValue(resp.idCliente + " - " + resp.nombreCliente1);
          } else {
            this.clienteInvalido = true;
            this.ordenBalanzaForm.controls['descli'].setValue('');
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.clienteInvalido = true;
          this.ordenBalanzaForm.controls['descli'].setValue('');
        }
      );
    }
  }

  imprimirCapturaEntradaLoading = false;
  imprimirCapturaEntrada() {
    this.imprimirCapturaEntradaLoading = true;
    this.ordenBalanzaService.imprimirCapturaEntrada(this.ordenSelected).subscribe(
      (resp) => {
        if (resp) {
          this._util.descargarArchivo("Orden-Balanza-" + resp.idOrden + ".pdf", resp);
          this.imprimirCapturaEntradaLoading = false;
          return;
        }
        this._util.mensajeErroToast('No se pudo imprimir correctamente.');
        this.imprimirCapturaEntradaLoading = false;
      },
      (error) => {
        console.log(error);
        this.imprimirCapturaEntradaLoading = false;
      }
    );
  }

  regresar() {
    this.ordenSelected = null;
  }

  regresarDesbloqueo() {
    (document.querySelector('.modal') as HTMLElement).style.zIndex = '99999';
    (document.querySelector('.modal') as HTMLElement).style.marginTop = '0px';
    (document.querySelector('body') as HTMLElement).style.overflow = 'hidden';
    (document.querySelector('.modal-backdrop') as HTMLElement).style.display = 'block';

    this.ordenSelectedView = false;
  }

  verOB(){
    console.log("Dato para ver orden de balanza", this.ordenSelected);

    this.ordenBalanzaForm.reset();
    this.ordenBalanzaForm.patchValue(this.ordenSelected);
    this.status = this.ordenSelected.estado;

    this.ordenBalanzaForm.get('estado')?.setValue(this.ordenSelected.estado);
    this.ordenBalanzaForm.get('tipo').setValue(this.ordenSelected.tipoOrden.desca);

    if(this.ordenSelected.tipoOrden.tipOrden == 0){
      this.ordenBalanzaForm.get('numero')?.setValue(this.ordenSelected.ordenCompra.idOrd);
      this.ordenBalanzaForm.get("ocStatus")?.setValue(this.ordenSelected.ordenCompra.estado);
      this.ordenBalanzaForm.get("solpedNumber")?.setValue(this.ordenSelected.ncasosSolped);
      this.ordenBalanzaForm.get("ocNumber")?.setValue(this.ordenSelected.ordenCompra.idOrd);
      this.ordenBalanzaForm.get("creationDateOC").setValue(this.ordenSelected.ordenCompra.fecha);
      this.ordenBalanzaForm.get("updateDateOC").setValue(this.ordenSelected.fechaActOrdCompra);
    }

    if(this.ordenSelected.tipoOrden.tipOrden != 0)
      this.ordenBalanzaForm.get("numero").setValue(this.ordenSelected.numOrdAlt);;
      this.ordenBalanzaForm.get('placa')?.setValue(this.ordenSelected.authTransp.placa);
      this.ordenBalanzaForm.get('chofer').setValue(this.ordenSelected.authTransp.chofer);
      this.ordenBalanzaForm.get('centroOri')?.setValue(this.ordenSelected.centroOri);
      this.ordenBalanzaForm.get('almanceOri')?.setValue(this.ordenSelected.almanceOri);
      this.ordenBalanzaForm.get('centroDest')?.setValue(this.ordenSelected.centroDest);
      this.ordenBalanzaForm.get('almaceDest')?.setValue(this.ordenSelected.almaceDest);
      this.ordenBalanzaForm.get('ticketAuth')?.setValue(this.ordenSelected.authTransp.idAuthTransp);
      this.ordenBalanzaForm.get('inspectionLotAcidity')?.setValue(this.ordenSelected.acidezSap);
      this.ordenBalanzaForm.get('inspectionLotMoisture')?.setValue(this.ordenSelected.humedadSap);
      this.ordenBalanzaForm.get('inspectionLotImpurity')?.setValue(this.ordenSelected.impurezaSap);
      this.ordenBalanzaForm.get("almanceOri").setValue(this.ordenSelected.almanceOri);
    
      /*-- AQUI REVISAR
      let userData = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
      this.ordenBalanzaForm.get('idusuario').setValue(userData.login);
      this.ordenBalanzaForm.get('usuario').setValue(userData.login2);
      this.ordenBalanzaForm.get('idusuario')?.setValue(this.ordenSelected.idusuario);
      */

    this.ordenBalanzaForm.get('fechIn')?.setValue(formatDate(this.ordenSelected.fechIn, 'dd-MM-yyyy', 'en'));
    this.ordenBalanzaForm.get('horaEntrada').setValue(formatDate(this.ordenSelected.fechIn, 'HH:mm', 'en'));
    this.ordenBalanzaForm.get('fechOut')?.setValue(formatDate(this.ordenSelected.fechOut, 'dd-MM-yyyy', 'en'));
    this.ordenBalanzaForm.get('horaSalida')?.setValue(formatDate(this.ordenSelected.fechOut, 'HH:mm', 'en'));
    this.ordenBalanzaForm.get('ordenFijaDescription')?.setValue(this.ordenSelected.bascula.desca);

    (document.querySelector('body') as HTMLElement).style.overflow = 'auto';
    (document.querySelector('.modal') as HTMLElement).style.zIndex = '-1';
    (document.querySelector('.modal') as HTMLElement).style.marginTop = '150px';
    (document.querySelector('.modal-backdrop') as HTMLElement).style.display = 'none';

    Object.keys(this.ordenBalanzaForm.controls).forEach(key => {
      this.ordenBalanzaForm.get(key).setValidators([]);
      this.ordenBalanzaForm.get(key).updateValueAndValidity();
      this.ordenBalanzaForm.get(key).disable();
    });

    this.onChangeCliente(event);
    this.onChangeProveedor(event);
    this.onChangeMaterial(event);
    this.ordenSelectedView = true;
  }

  imprimirCapturaSalidaLoading = false;
  imprimirCapturaSalida() {
    this.imprimirCapturaSalidaLoading = true;
    this.ordenBalanzaService.imprimirCapturaSalida(this.ordenSelected).subscribe(
      (resp) => {
        if (resp) {
          this._util.descargarArchivo("Orden-Balanza-" + resp.idOrden + ".pdf", resp);
          this.imprimirCapturaSalidaLoading = false;
          return;
        }
        this._util.mensajeErroToast('No se pudo imprimir correctamente.');
        this.imprimirCapturaSalidaLoading = false;
      },
      (error) => {
        console.log(error);
        this.imprimirCapturaSalidaLoading = false;
      }
    );
  }
  
  buscarDesbloqueos(){
    this.tituloGrid = "Busqueda de Histórico";
    this.loading = true;
    let data = this.frmFiltros.getRawValue();
    
    let para = Object.keys(data)
                      .filter(key => data[key])
                      .map(key => `${key}=${encodeURIComponent(data[key])}`)
                      .join('&');
    
    this.desbloqueoOrdenBalanzaS.buscarDesbloqueosFiltros(para).subscribe(
      (resp) => {
        if (resp) {
          resp.map(e => {
            e['id']    = e.id
            e['fecha'] = e.fechaAuth;
            e['tipo_bloqueo'] = e.tipo;
            e['idOrden'] = e.ordenbalanza;
            e['idbloqueo'] = e.id;
            e['estado_orden'] = e.motivo
            e['usuario'] = e.usuarioAutoriza,
            e['autorizado'] = e.usuarioAutoriza
            e['difPeso'] = e.difPeso;
            e['difAcidez'] = e.difAcidez;
            e['difHI'] = e.difHumedadimp;
            e['secuencia'] = e.secuencia;
            return e;
          }).sort((a, b) => (parseInt(a.id) > parseInt(b.id) ? -1 : 1));
          this.rowData = resp;
        }
      },
      (error) => {
        this.rowData = [];
        console.log(error.error.mensaje);
      }
    );
    this.loading = false;

  }

  iniciarlizarCombos(){
    // Combo de Usuarios Aprobadores
    this.subscription.add(
      this.MantenimientoUsuarioAprobadorService.obtener().subscribe(
        resp => {this.cmbUsuarios = resp;},
        error => {this._util.alertifyToast("ERROR EN LA LISTA DE USUARIOS APROBADORES");}
      )
    );

    //Combo de Motivos de bloquos
    this.subscription.add(
      this.ConfiguracionMotivosDeDesbloqueosService.obtener().subscribe(
        (resp) => { this.listMotivos = resp;},
        (error) => {this.listMotivos = [];}
      )
    );

  }

}
